export default "__VITE_ASSET__771256f5__"